import { Injectable } from '@angular/core';
import { BaseHubService } from './base-hub.service';
import { HttpClient } from '@angular/common/http';
import { MessageService } from '../local/message.service';
import { IRapportSousSystemeRaw } from '../../_models/RapportSousSysteme';
import { ConfigService } from '../local/config.service';
import { Store } from '@ngrx/store';
import { MainStoreState } from '../../_store/mainStoreState';
import { setRapportsSousSystemesAction } from '../../_store/RapportSousSystemeStore/rapport-sous-systeme.store';
import { IBaseObject } from '../../_models/BaseObject';

@Injectable({
  providedIn: 'root',
})
export class RapportSousSystemeService extends BaseHubService<IRapportSousSystemeRaw> {
  constructor(private store: Store<MainStoreState>, http: HttpClient, messageService: MessageService, configService: ConfigService) {
    super('rapport-sous-systemes', 'hubs/rapportSousSystemesHub', 'Rapport sous-systèmes', http, messageService, configService);
  }

  refreshHubConnection(): Promise<void> {
    return this.start();
  }

  closeHubConnection(): Promise<void> {
    return this.stop();
  }

  protected dispatchUpdateData(data: IBaseObject[]): void {
    this.store.dispatch(
      setRapportsSousSystemesAction({
        payload: data as IRapportSousSystemeRaw[],
      })
    );
  }
}
